
<!-- DeliveryPointModal.svelte -->

<script>
  import { createEventDispatcher, onMount } from 'svelte';
  const dispatch = createEventDispatcher();


  export let isOpen = false;
  export let deliveryPoints = [];
  export let isLoading = false;



  onMount(() => {
    isLoading = false;
  });
  
  function handleClose() {
    dispatch('close');
  }
  function handleSelection(deliveryPointId) {
    if (Number.isInteger(deliveryPointId) && deliveryPointId >= 0) {
      dispatch('select', deliveryPointId);
      handleClose();
    } else {
      console.error('Invalid delivery point ID:', deliveryPointId);
    }
  }
</script>

<style>



* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.safe-area-bottom {
  padding-bottom: 20px;
}

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1000;
  }


  .modal-content {
    background-color: #fff;
    padding: 20px;
    padding-top: calc(20px + env(safe-area-inset-top));
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
  }


  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    background-color: #f8f8f8;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 17px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .delivery-point-area-label {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
  }

  .delivery-point-name {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    margin-bottom: 6px;
  }
  .delivery-point-address {
    font-size: 14px;
    color: #666;
    margin-bottom: 2px;
  }

  .delivery-point-timings {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    margin-top: 6px;
  }

  .modal-select-button {
    background-color: #007AFF;
    color: white;
    border: none;
    padding: 12px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    transition: background-color 0.2s ease;
  }
  .modal-select-button:hover {
    background-color: #0056b3;
  }
  .close-button {
    position: absolute;
    top: calc(20px + env(safe-area-inset-top));
    right: 20px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
  }
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
  .dot {
    width: 10px;
    height: 10px;
    background-color: #007AFF;
    border-radius: 50%;
    margin: 0 5px;
    animation: bounce 0.5s ease-in-out infinite;
  }
  .dot:nth-child(2) {
    animation-delay: 0.1s;
  }
  .dot:nth-child(3) {
    animation-delay: 0.2s;
  }
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
</style>

{#if isOpen}
  <div class="modal-overlay" on:click={handleClose}>
    <div class="modal-content" on:click|stopPropagation>
      <button class="close-button" on:click={handleClose}>&times;</button>
      <h2>Select Delivery Point</h2>
      {#if isLoading}
        <div class="loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      {:else if deliveryPoints.length > 0}
        <ul>
          {#each deliveryPoints as deliveryPoint}
            <li>
              <div class="delivery-point-area-label">{deliveryPoint.area_label}</div>
              <div class="delivery-point-name">{deliveryPoint.name}</div>
              <div class="delivery-point-address">{deliveryPoint.address}</div>

			  {#if deliveryPoint.timings}
				<p class="delivery-point-timings">Shop Timings: {deliveryPoint.timings}</p> 
			  {/if}


              <button class="modal-select-button" on:click={() => handleSelection(deliveryPoint.id)}>Select</button>
            </li>
          {/each}
        </ul>
      {:else}
        <p>No delivery points found.</p>
      {/if}
    </div>
  </div>
{/if}